import urlPrefix from "./apiPrefix";

export const getStatsNOSystem = () => `${urlPrefix.value}/tax-web-control/stats/no/system`;
export const getStatsNOSystemRange = () => `${urlPrefix.value}/tax-web-control/stats/no/system/range`;
export const getStatsNOSystemRangeMonth = () => `${urlPrefix.value}/tax-web-control/stats/no/system/range/month`;
export const getStatsNOSystemByCalcItemAttrs = () => `${urlPrefix.value}/tax-web-control/stats/no/system/by-calc-item-attrs`;
export const getTaxiStatsTopByRevenue = () => '/tax-web-control/api/taxi/stats/top-by-revenue';
export const getTaxiStatsSystem = () => '/tax-web-control/api/taxi/stats/system';
export const getTaxiLastTickets = () => '/tax-web-control/api/taxi/last-tickets';
